<app-navbar />

@if (solution(); as s) {
  <main id="main-content">
    <section class="page-hero">
      <div class="container">
        <app-breadcrumb [trail]="[{ label: 'Solutions', url: routes.solutions.url }, { label: s.name }]" />
        <span class="eyebrow">{{ s.heroEyebrow }}</span>
        <h1>{{ s.heroTitle }}</h1>
        <p>{{ s.heroLead }}</p>
        <div class="actions-row">
          <a class="btn btn-primary btn-lg" [routerLink]="[routes.accountRegister.url]">Get started</a>
          <a class="btn btn-outline btn-lg" [routerLink]="[routes.contact.url]">Talk to sales</a>
        </div>
        <ul class="hero-trust">
          <li><strong>7 days</strong><span>Typical record freshness</span></li>
          <li><strong>50 states</strong><span>Nationwide coverage</span></li>
          <li><strong>$0.04</strong><span>Per confirmed record</span></li>
        </ul>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="grid-2 align-start">
          <div>
            <span class="eyebrow">The problem</span>
            <h2 class="section-title">The gap that fraud exploits</h2>
            <p class="section-lead">{{ s.problem }}</p>
          </div>
          <div class="card">
            <h3>Common challenges</h3>
            <ul class="check-list cross-list">
              @for (challenge of s.challenges; track challenge) {
                <li>{{ challenge }}</li>
              }
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-alt">
      <div class="container">
        <div class="section-head">
          <span class="eyebrow">Why VerifyDeceased</span>
          <h2 class="section-title">What you get</h2>
        </div>
        <div class="grid-3">
          @for (benefit of s.benefits; track benefit.title) {
            <div class="feature-card">
              <span class="icon-badge" [innerHTML]="iconFor(s.icon)"></span>
              <h3>{{ benefit.title }}</h3>
              <p>{{ benefit.description }}</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="grid-2 align-start">
          <div>
            <span class="eyebrow">Use cases</span>
            <h2 class="section-title">How teams put it to work</h2>
            <p class="section-lead">
              Start with a batch scrub of your existing records, then move to real time checks as you
              integrate the API.
            </p>
          </div>
          <ul class="check-list">
            @for (useCase of s.useCases; track useCase) {
              <li>{{ useCase }}</li>
            }
          </ul>
        </div>
      </div>
    </section>

    @if (s.faqs.length) {
      <section class="section section-alt">
        <div class="container">
          <div class="section-head">
            <span class="eyebrow">Questions</span>
            <h2 class="section-title">Frequently asked questions</h2>
          </div>
          <div class="faq-list">
            @for (faq of s.faqs; track faq.question) {
              <details class="faq-item">
                <summary>{{ faq.question }}</summary>
                <p>{{ faq.answer }}</p>
              </details>
            }
          </div>
        </div>
      </section>
    }

    @if (related().length) {
      <section class="section">
        <div class="container">
          <div class="section-head">
            <span class="eyebrow">More solutions</span>
            <h2 class="section-title">Explore other teams we help</h2>
          </div>
          <div class="grid-3">
            @for (item of related(); track item.slug) {
              <a class="feature-card solution-link" [routerLink]="[routes.solutions.url, item.slug]">
                <span class="icon-badge" [innerHTML]="iconFor(item.icon)"></span>
                <h3>{{ item.name }}</h3>
                <p>{{ item.cardDescription }}</p>
                <span class="link-more">Explore this solution</span>
              </a>
            }
          </div>
        </div>
      </section>
    }

    <section class="section">
      <div class="container">
        <div class="cta-band">
          <h2>Put fresh death data to work for {{ s.name.toLowerCase() }}</h2>
          <p>Create an account and pay only for the records we confirm, or talk to our team first.</p>
          <div class="actions-row center">
            <a class="btn btn-primary btn-lg" [routerLink]="[routes.accountRegister.url]">Create your free account</a>
            <a class="btn btn-outline btn-lg" [routerLink]="[routes.pricing.url]">View pricing</a>
          </div>
        </div>
      </div>
    </section>
  </main>
}

<app-footer />
